const defVal = 1;

export const RGBA_COLORS = {
  getAccent: (opacity: number = defVal) => `rgba(26,130,197, ${opacity})`,
  getDefault: (opacity: number = defVal) => `rgba(50, 51, 50, ${opacity})`,
  getDanger: (opacity: number = defVal) => `rgba(245, 34, 45, ${opacity})`,
};
